/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var OpportunitiesIcon = createIcon("OpportunitiesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9a2 2 0 111.933 1.999L19.98 17.64a.5.5 0 01-.48.359h-15a.5.5 0 01-.48-.359L2.067 11A2 2 0 114 9c0 .18-.025.355-.073.525l1.93 1.103a2.825 2.825 0 004.047-1.462l.95-2.532A1.991 1.991 0 0110 5a2 2 0 114 0c0 .666-.33 1.268-.853 1.634l.95 2.532a2.825 2.825 0 004.047 1.462l1.93-1.103A1.927 1.927 0 0120 9Z",
    fill: "#FFC06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17a2 2 0 110 4H4a2 2 0 110-4h16Z",
    fill: "#FF9E1B"
  })));
}, {});